<template>
  <transition name="banner-info">
    <div class="banner flex center" :class="category" v-if="show">
      <span>{{content}}</span>
    </div>
  </transition>
</template>
<script>
/// ///////////////////////////////////
// IMPORT
/// //////////////////////////////////
import { EventBus, NOTIFICATION_INFO } from '@/model/EventBus'
import { mapGetters } from 'vuex'
/// ///////////////////////////////////
// CLASS
/// //////////////////////////////////
export default {
  name: 'BannerInfo',
  components: {},
  beforeCreate() {},
  async created() {
    this.dictionnary = await this.getLanguages
    EventBus.$on(NOTIFICATION_INFO, data => {
      this.content = this.dictionnary[data.type][data.code]
      this.category = data.class
      this.show = true
      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(() => (this.show = false), 5000)
    })
  },
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  data() {
    return {
      show: false,
      category: 'danger',
      content: '',
      timer: null,
      dictionnary: null
    }
  },
  props: {},
  computed: {
    ...mapGetters(['getLanguages'])
  },
  methods: {},
  watch: {}
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/infos/BannerInfo.vue